export const fixString = (string: string, maxLength: number, cut: boolean) => {
  if (!string || !string.length) return ''

  let text = string.replace(/([A-Z])/g, ' $1').trim()

  // exception: make "To" lowercase
  text = text.replace(/\bTo\b/g, 'to')

  return cut ? (text.length > maxLength ? text.slice(0, maxLength - 3) + '...' : text) : text
}